module.exports = __webpack_public_path__ + "static/img/img1.a7b3b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/img1.png
// module id = Lfuu
// module chunks = 0